export default ".fixedHeaderContainer.sticky header > a img, .separateOnPageNav .fixedHeaderContainer header > a img {\n  height: 30px;\n}\n"